import ImageComponent from "../../utils/ImageComponent";
import FeatureAreaCard from "./FeatureAreaCard";
import "./FeatureArea.css";

export default function FeatureArea() {
  return (
    <div className="feature_area">
      <div className="container">
        <h2 className="text-center">Everything you'll ever need</h2>
        <span className="feature-heading-rule" aria-hidden="true" />
        <div className="row">
          <div className="col-lg-4 col-md-6 mt_30">
            <FeatureAreaCard
              image="/img/seo-report.svg"
              heading="AI Document Scan"
              accent="blue"
              paragraph="Snap a photo of a bill or invoice. The AI reads the vendor, date, invoice number, items and total, then files the entry for you — no typing, no duplicates."
            />
          </div>
          <div className="col-lg-4 col-md-6 mt_30">
            <FeatureAreaCard
              image="/img/bar-chart.svg"
              heading="Insights & Reports"
              accent="green"
              paragraph="Business-wide insights built from your own books: how cash is trending, who owes you, what you owe and which bills fall due next — plus Excel and PDF exports."
            />
          </div>
          <div className="col-lg-4 col-md-6 mt_30">
            <FeatureAreaCard
              image="/img/sleekdesign.svg"
              heading="Android, iPhone & Web"
              accent="cyan"
              paragraph="One account across every device you work on. Your books stay in sync, and the invoice links you send open in any browser — no app required."
            />
          </div>
          <div className="col-lg-4 col-md-6 mt_30">
            <FeatureAreaCard
              image="/img/invoice.svg"
              heading="Beautiful Invoices"
              accent="rose"
              paragraph="Create invoices from a library of professionally designed templates, send them straight to your customer, and see what is paid and what is overdue."
            />
          </div>
          <div className="col-lg-4 col-md-6 mt_30">
            <FeatureAreaCard
              image="/img/inventory.svg"
              heading="Inventory Management"
              accent="teal"
              paragraph="Manage products and services, scan barcodes or add items by hand, and raise a sales invoice straight from your inventory."
            />
          </div>
          <div className="col-lg-4 col-md-6 mt_30">
            <FeatureAreaCard
              image="/img/database.svg"
              heading="Cloud Storage & Security"
              accent="violet"
              paragraph="Every receipt, invoice and report is backed up in the Microsoft cloud and encrypted with industry-standard protocols, so you never lose a record."
            />
          </div>
        </div>
      </div>
      <ImageComponent src="/img/icon3.svg" className="icon1" />
    </div>
  );
}
